import { forceStaging } from './forceStaging';
import { fetcher } from '@weezevent/weezjs-core';

export const BASE_FINANCE_ENTITIES_URL = '/finance-entities/v1';
export const BASE_URL_FORCED = forceStaging(window.weezConfig.api.apiUrl);

export const financeFetcher = {
    get: (url, options = {}) => {
        return fetcher.get(`${BASE_FINANCE_ENTITIES_URL}${url}`, {
            endpoint: BASE_URL_FORCED,
            ...options
        });
    },
    post: (url, options = {}) => {
        return fetcher.post(`${BASE_FINANCE_ENTITIES_URL}${url}`, {
            method: 'POST',
            endpoint: BASE_URL_FORCED,
            ...options
        });
    },
    put: (url, options = {}) => {
        return fetcher.put(`${BASE_FINANCE_ENTITIES_URL}${url}`, {
            method: 'PUT',
            endpoint: BASE_URL_FORCED,
            ...options
        });
    },
    delete: (url, options = {}) => {
        return fetcher.delete(`${BASE_FINANCE_ENTITIES_URL}${url}`, {
            method: 'DELETE',
            endpoint: BASE_URL_FORCED,
            ...options
        });
    },
    patch: (url, options = {}) => {
        return fetcher.patch(`${BASE_URL_FORCED}${url}`, {
            method: 'PATCH',
            endpoint: BASE_URL_FORCED,
            ...options
        });
    }
};
